import { motion, AnimatePresence } from 'framer-motion';
import clsx from 'clsx';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  buttons?: React.ReactNode;
  overlay?: boolean;
  overlayClose?: () => void;
  className?: string;
  buttonsContainerClassNames?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  buttons,
  overlay = true,
  overlayClose,
  className = '',
  buttonsContainerClassNames = '',
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div
          data-testid="modal-overlay"
          className="fixed inset-0 !z-10 flex items-center justify-center"
        >
          {overlay && (
            <motion.div
              data-testid="modal-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0, transition: { duration: 0.2 } }}
              className="fixed inset-0 bg-amberblack-soft backdrop-blur-[6px]"
              onClick={overlayClose || onClose}
            />
          )}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }}
            className={clsx(
              'fixed z-50 p-[20px] tablet:px-[32px] tablet:pt-[32px] tablet:pb-[28px] bg-paper border border-gray shadow-black-cta-shad rounded-[12px] tablet:rounded-[16px] mx-24 tablet:w-[500px] desktop:w-[500px] overflow-hidden',
              className,
            )}
          >
            {title && <div className="pb-[16px] tablet:pb-24 text-ashgray">{title}</div>}
            <div>{children}</div>
            {buttons && (
              <div
                className={clsx(
                  'flex justify-end pt-[32px] tablet:pt-[48px]',
                  buttonsContainerClassNames,
                )}
              >
                {buttons}
              </div>
            )}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
